import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { ITag } from '../types/ITag';

export interface IGetTagsParams extends IGetItemsParams {
}

export interface IGetTagsResult extends IGetItemsResult {
  tags: ITag[];
}

export class GetTagsRequest extends Request<IGetTagsParams, IGetTagsResult> {
  constructor(params: IGetTagsParams) {
    super('getTags', params);
  }
}
